import countUp from 'countup.js';
import scrollMonitor from 'scrollmonitor';

const $callout = $('.service-callout');

const setupScroll = () => {
    const $count = $callout.find('.count').first();
    const counter = new countUp($count.get(0), 0, $count.data('total'), 0, 1, {
        useEasing: false,
    });
    const countWatcher = scrollMonitor.create($count.get(0));

    countWatcher.enterViewport(() => {
        $count.addClass('active');
        counter.start();
        countWatcher.destroy();
    });
};

export default {
    can: () => $callout.length,
    run: () => {
        setupScroll();
    },
};
